import { render, staticRenderFns } from "./youyan.vue?vue&type=template&id=be384750&scoped=true&"
import script from "./youyan.vue?vue&type=script&lang=js&"
export * from "./youyan.vue?vue&type=script&lang=js&"
import style0 from "./youyan.vue?vue&type=style&index=0&id=be384750&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be384750",
  null
  
)

export default component.exports